/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegularWithdrawalViewModel
 */
export interface RegularWithdrawalViewModel {
    /**
     * 
     * @type {number}
     * @memberof RegularWithdrawalViewModel
     */
    grossAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof RegularWithdrawalViewModel
     */
    frequency?: string;
    /**
     * 
     * @type {Date}
     * @memberof RegularWithdrawalViewModel
     */
    nextPaymentDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof RegularWithdrawalViewModel
     */
    growthRateDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof RegularWithdrawalViewModel
     */
    growthRate?: number;
}

/**
 * Check if a given object implements the RegularWithdrawalViewModel interface.
 */
export function instanceOfRegularWithdrawalViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RegularWithdrawalViewModelFromJSON(json: any): RegularWithdrawalViewModel {
    return RegularWithdrawalViewModelFromJSONTyped(json, false);
}

export function RegularWithdrawalViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegularWithdrawalViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'grossAmount': !exists(json, 'GrossAmount') ? undefined : json['GrossAmount'],
        'frequency': !exists(json, 'Frequency') ? undefined : json['Frequency'],
        'nextPaymentDate': !exists(json, 'NextPaymentDate') ? undefined : (new Date(json['NextPaymentDate'])),
        'growthRateDate': !exists(json, 'GrowthRateDate') ? undefined : (new Date(json['GrowthRateDate'])),
        'growthRate': !exists(json, 'GrowthRate') ? undefined : json['GrowthRate'],
    };
}

export function RegularWithdrawalViewModelToJSON(value?: RegularWithdrawalViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'GrossAmount': value.grossAmount,
        'Frequency': value.frequency,
        'NextPaymentDate': value.nextPaymentDate === undefined ? undefined : (value.nextPaymentDate.toISOString()),
        'GrowthRateDate': value.growthRateDate === undefined ? undefined : (value.growthRateDate.toISOString()),
        'GrowthRate': value.growthRate,
    };
}

